import * as React from "react";
const CompositeListContext = /* @__PURE__ */ React.createContext({
  register: () => {
  },
  unregister: () => {
  },
  subscribeMapChange: () => () => {
  },
  nextIndexRef: {
    current: 0
  }
});
if (process.env.NODE_ENV !== "production") CompositeListContext.displayName = "CompositeListContext";
function useCompositeListContext() {
  return React.useContext(CompositeListContext);
}
export {
  CompositeListContext,
  useCompositeListContext
};
//# sourceMappingURL=CompositeListContext.js.map
